module.exports = __webpack_public_path__ + "img/icon-descargar-pdf.0f893c10.svg";